// インドの森: A11y修正パッチ（2026-04-28）
// 軽微なアクセシビリティ問題4件を実行時補正
(function () {
  function fixHeroImage() {
    document.querySelectorAll('.image-with-text__media img').forEach(function (img) {
      if (!img.alt || !img.alt.trim()) {
        img.alt = 'タージマハル — インドの世界遺産';
      }
    });
  }

  function fixPoingPongButton() {
    document.querySelectorAll('.poingpong2__floating, button.poingpong2__floating, [class*="poingpong"][class*="floating"]').forEach(function (el) {
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'レビュー・お知らせを開く');
      }
      var img = el.querySelector('img');
      if (img && (!img.alt || !img.alt.trim())) {
        img.alt = '';  // Decorative since button has aria-label
        img.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function fixCartItemLinks() {
    document.querySelectorAll('.cart-item__link').forEach(function (a) {
      if (a.getAttribute('aria-label')) return;
      // Find the product title in the same cart item row
      var item = a.closest('.cart-item, tr, li, .cart-drawer__item') || a.parentElement;
      var titleEl = item && item.querySelector('.cart-item__name, .cart-item__title, a[href*="/products/"]:not(.cart-item__link), .h4');
      var title = titleEl ? titleEl.textContent.trim() : '';
      if (!title) {
        // Fallback: extract product handle from href
        var m = a.href.match(/\/products\/([^?#]+)/);
        title = m ? m[1].replace(/-/g, ' ') : '商品';
      }
      a.setAttribute('aria-label', title + 'の商品ページを開く');
    });
  }

  function applyAll() {
    fixHeroImage();
    fixPoingPongButton();
    fixCartItemLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  // Re-apply after dynamic insertions (cart drawer updates, app loads)
  var observer = new MutationObserver(function () {
    applyAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
